import React from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Divider from '@mui/material/Divider';

export const SwitchOrganizationSettings = () => {
	return (
		<>
			<Toolbar>
				<span>Switch Organization</span>
			</Toolbar>
			<Divider />
			<Box sx={{ pl: 3 }}>
				<p>Switch Organization</p>
			</Box>
		</>
	);
};
